var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_352270_close_icon",
    "data-name": "352270_close_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.666,
    height: 31.666,
    viewBox: "0 0 31.666 31.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M28.472,11.867,26.6,10l-7.369,7.369L11.867,10,10,11.867l7.369,7.369L10,26.6l1.867,1.867L19.236,21.1,26.6,28.472,28.472,26.6,21.1,19.236Z",
    transform: "translate(-3.403 -3.403)",
    fill: "#cc0e2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M0,0H31.666V31.666H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseActive);
export default __webpack_public_path__ + "static/media/CloseActive.a898e122459634a6dd3d1dd256bcab2d.svg";
export { ForwardRef as ReactComponent };